import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Async thunk to fetch all marquees
export const fetchAllMarquees = createAsyncThunk(
    'marquees/fetchAllMarquees',
    async (_, { rejectWithValue }) => {
        try {
            await new Promise((resolve) => setTimeout(resolve, 1000)); // Force delay
            const response = await axios.get('api/v1/get_all_marquees');
            return response.data.marquees || [];
        } catch (err) {
            console.error('Failed to fetch marquees:', err);
            return rejectWithValue(err.response?.data || 'Unknown error');
        }
    }
);

const marqueesSlice = createSlice({
    name: 'marquees',
    initialState: {
        allMarquees: [],
        loading: false,
        error: null,
    },
    reducers: {
        setAllMarquees(state, action) {
            state.allMarquees = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllMarquees.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAllMarquees.fulfilled, (state, action) => {
                state.loading = false;
                state.allMarquees = action.payload;
            })
            .addCase(fetchAllMarquees.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { setAllMarquees } = marqueesSlice.actions;
export default marqueesSlice.reducer;
